export function createRoutes() {
  return [
    {
      path: 'collections',
      component: () => import(/* webpackChunkName: "CollectionChrome" */ './CollectionChrome.vue'),
      children: [
        {
          path: '/',
          name: 'collectionList',
          component: () => import(/* webpackChunkName: "CollectionList" */ './CollectionList.vue'),
        },
        {
          path: ':collectionId',
          component: () => import(/* webpackChunkName: "CollectionEditChrome" */ './CollectionEditChrome.vue'),
          children: [
            {
              path: '/',
              component: () => import(/* webpackChunkName: "CollectionEdit" */ './CollectionEdit.vue'),
            },
          ],
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
